import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
  fetching: true,
  loggedIn: false,
  userVerified: undefined,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, {payload = {}}) => ({
      ...state,
      ...payload,
    }),
    unsetAuth: () => ({
      ...initialState,
    }),
  },
});

export const authState = state => state.auth;

export const {setAuth, unsetAuth} = authSlice.actions;

export default authSlice.reducer;
